import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

// @Component({
//   selector: 'app-studymaterials',
//   templateUrl: './studymaterials.component.html',
//   styleUrls: ['./studymaterials.component.scss']
// })
@Component({
  selector: 'app-studymaterials',
  standalone: true,
  imports: [
    CommonModule, // for *ngIf, *ngFor, ngStyle, etc.
    FormsModule, // for [(ngModel)]
    ReactiveFormsModule, // for formGroup and formControlName
  ],
  templateUrl: './studymaterials.component.html',
  styleUrls: ['./studymaterials.component.scss'],
})
export class StudymaterialsComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  materialName: any;
  cources: any[];
  courseData: any;
  showAdd = false;
  showEdit = false;
  id: any;
  materialdata: any[];
  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    courseval: [{ type: 'required', message: 'Please enter course' }],
  };
  adminName: any;
  adminImage: any;
  allCourse: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      courseval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  deletematerialcategory(id) {
    this.spinner.show();
    let payload = {
      id: id,
    };
    const servicePath = this.utils.getApiConfigs('materialcatergory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Category Delete Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.courseForm.reset();
    // Get All Courses \\
    const servicePathDistrict = this.utils.getApiConfigs('course');
    this.commonservice
      .invokeService(
        servicePathDistrict[1].method,
        servicePathDistrict[1].path,
        ''
      )
      .then((resp: any) => {
        // console.log("Course", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.courseData = resp.data;

          if (this.courseData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.allCourse = this.courseData;
      });
    this.getmaterialcategory();
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.courseData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allCourse = this.allData.filter((item) =>
        item.courses.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allCourse == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  addMaterial() {
    this.spinner.show();
    let payload = {
      category: this.materialName,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('category');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess(
            'Material Category added Successfully'
          );
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }

  getmaterialcategory() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('getcategory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          console.log('----------------------', this.materialdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  editCourse(data) {
    // console.log("Data", data);
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.materialName = data.category;
    this.id = data.id;
  }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  updateCourse() {
    this.spinner.show();
    let payload = {
      courses: this.materialName,
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('course');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course updated successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
